import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { catalogMenu } from '../../slice/catalogMenu';
import store from '../../../store';
import { menuItems } from './menuItems';
import { Menu } from './Menu';

const newCatalogMenu = (id, items, brands) => {
  const node = document.getElementById(id);
  if (node === null) {
    throw new Error(`catalog menu error: target DOM node is null: #${id}`);
  }

  const newNode = document.createElement('div');
  node.replaceWith(newNode);

  const root = ReactDOM.createRoot(newNode);
  root.render(
    <Provider store={store}>
      <Menu items={items} brands={brands} />
    </Provider>,
  );
};

const CatalogMenu = () => {
  const onClick = (evt) => {
    const exists = store.getState().catalogMenu.exists;
    if (!exists) {
      const items = menuItems('catalog-menu', window.location.pathname);
      const brands = window.brandByMenu;
      newCatalogMenu('catalog-menu', items, brands);
      store.dispatch(catalogMenu.actions.start());
    }

    store.dispatch(catalogMenu.actions.resetSubMenu());
    store.dispatch(catalogMenu.actions.toggle());
    evt.stopPropagation();
  };

  const menuTrigger = document.getElementById('show-catalog-menu');
  menuTrigger.addEventListener('click', onClick);

  const menuTriggerInHeader = document.getElementById(
    'catalog-trigger-in-header',
  );
  if (menuTriggerInHeader !== null) {
    menuTriggerInHeader.addEventListener('click', (evt) => {
      const menu = document.getElementById('site-menu');
      const trigger = document.getElementById('show-site-menu');
      trigger.classList.toggle('close-menu');
      menu.classList.toggle('transition-menu');
      onClick(evt);
    });
  }

  const menuMobTrigger = document.getElementById('show-mob-catalog-menu');
  menuMobTrigger.addEventListener('click', onClick);

  const menuIcon = document.getElementById('catalog-menu-icon');
  store.subscribe(() => {
    const { visible } = store.getState().catalogMenu;
    if (visible) {
      menuIcon.classList.add('opened');
    } else {
      menuIcon.classList.remove('opened');
    }
  });
};

export default CatalogMenu;
